export enum ReservationStatus {
  Finished = 0,
  Waiting = 1,
  InProgress = 2,
  Skipped = 3,
}

export enum UIReservationStatus {
  All = 4,
  Finished = 0,
  Waiting = 1,
  InProgress = 2,
  Skipped = 3,
}

export type RestaurantReservationParams = {
  floor: string;
  table: string;
};

export type Reservation<E extends any> = {
  id: number;
  location_id: string;
  email: string | undefined | null;
  phone: string | undefined | null;
  firstName: string;
  lastName: string;
  numberOfPeople: number;
  status: ReservationStatus;
  created_date: number;
  reserved_date: string;
  duration: number;
  extra: E;
};

export type BookingSetting = {
  id: number;
  last_modified_date: Date;
  late_tolerance: number;
  auto_skipped_if_late: boolean;
  max_number_of_people: number;
  duration: number;
  open_hour: number;
  closed_hour: number;
};

export type RestaurantReservation = Reservation<RestaurantReservationParams>;

export type BookingSettingInitParams = Pick<
  BookingSetting,
  | 'auto_skipped_if_late'
  | 'duration'
  | 'closed_hour'
  | 'late_tolerance'
  | 'max_number_of_people'
  | 'open_hour'
>;
export type UpsertBookingSettingPayload = Partial<BookingSettingInitParams>;
